import { DataLayerItem } from '../../types';

import { hasDataLayer } from '../has-data-layer';
import { pushDataToGtmFromDataset } from '../push-data-ga-from-dataset';

export const analyticsInputHandler = (target: EventTarget, additionalDataForGA: DataLayerItem) => {
  if (!(target instanceof HTMLInputElement)) {
    return;
  }

  if (!target.dataset.gaEvent) {
    return;
  }

  if (!hasDataLayer()) {
    return;
  }

  pushDataToGtmFromDataset(target, additionalDataForGA);
};
